import { render } from "./edit-article.vue?vue&type=template&id=5c46ea10&ts=true"
import script from "./edit-article.vue?vue&type=script&lang=ts"
export * from "./edit-article.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__